import {
    PostCheckoutMandatoryCustomQuestionsVariant,
    PostCheckoutMandatoryQuestionsInAppVariant,
} from '../../constants/statsig';
import { CheckoutState } from '../../state';
import {
    getPostCheckoutMandatoryCustomQuestions,
    getPostCheckoutMandatoryQuestionsInApp,
} from '../../utils/statsig';
import { isPostCheckoutMandatoryQuestionsElegible } from '../postCheckoutMandatoryQuestions/isPostCheckoutMandatoryQuestionsElegible';
import {
    getIsPaymentView,
    isOrganizerQuestionsPage,
    isPreTicketsOrganizerQuestionsPage,
} from '../routing';

export const shouldPrefillFirstAttendeeBasicInfoQuestions = (
    state: CheckoutState,
) => {
    const displayAttendeeBasicInfoQuestionsAfterPayment =
        isPostCheckoutMandatoryQuestionsElegible(state) ||
        getPostCheckoutMandatoryCustomQuestions() ===
            PostCheckoutMandatoryCustomQuestionsVariant.customQuestions ||
        getPostCheckoutMandatoryQuestionsInApp() ===
            PostCheckoutMandatoryQuestionsInAppVariant.customQuestionsInApp;

    const isPreOrderOrPreticketsPage =
        isOrganizerQuestionsPage(state) ||
        isPreTicketsOrganizerQuestionsPage(state);

    return (
        (getIsPaymentView(state) &&
            !displayAttendeeBasicInfoQuestionsAfterPayment) ||
        (isPreOrderOrPreticketsPage &&
            displayAttendeeBasicInfoQuestionsAfterPayment)
    );
};
